module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/2023/area-icon4-48c4bb9a3a161d01d72fc993306e701e.svg&quot;;"